import loadable from '@loadable/component';

const DashboardPage = loadable(() => import('./page'));

export const routes = [
  {
    path: '',
    element: <DashboardPage />,
  },
];
